import { Component, OnInit,ViewChild,ElementRef } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Location } from '@angular/common';
import { ApifirstService } from 'src/app/service/apifirst.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-report-a-problem-page',
  templateUrl: './report-a-problem-page.component.html',
  styleUrls: ['./report-a-problem-page.component.scss']
})
export class ReportAProblemPageComponent implements OnInit {
  showPopup: any = false;
  tokenDetails: any
  userId: any
  firstName: string = '';
  lastName: string = '';
  phoneNumber: any
  email: any = '';
  description: any
  fileToUpload: any = null
  filename: any = "";
  vinDetail: any
  year: any
  model: any
  vin: any
  value: string = '';
  tokenDet: any
  rap1: any
  fileType: any
  RAPDataAvailable: boolean = false;
  paraDisplay = true;
  getRAPData = true;
  editUsInfo = true;
  req = {};
  submitError = true;
  firstNameError = false
  lastNameError = false
  phoneNumberError = false
  emailError = false
  detailsError = false
  emailValidError = false
  filesizeError = false;
  Gnumber: string = '';
  showloader: boolean = false;
  gnumberSubscription: Subscription = new Subscription;
  @ViewChild('GETUSERINFOERRORPOPUP') GETUSERINFOERRORPOPUP: ElementRef | undefined;
  @ViewChild('RAPSubmissionErrorPopup') RAPSubmissionErrorPopup: ElementRef | undefined;
  @ViewChild('RAPSubmitSuccessPopup') RAPSubmitSuccessPopup: ElementRef | undefined;

  constructor(public activeModal: NgbActiveModal, private modalService: NgbModal, public translate: TranslateService, private service: ApifirstService, public location: Location,) { }

  ngOnInit(): void {
    this.service.tokenObj.subscribe((data) => {
      this.tokenDetails = data
      console.log(this.tokenDetails, "token")
      if(this.tokenDetails.countryThree == 'ROM') {
        this.tokenDetails.countryThree = 'ROU'
      }
      this.userId = this.tokenDetails.username
      this.vin = this.tokenDetails.vin
      // this.firstName = this.tokenDetails.firstName;
      // this.lastName = this.tokenDetails.lastName;
      // this.phoneNumber = this.tokenDetails.phone;
      // this.email = this.tokenDetails.email;
    })
    const vin = {
      "vin": this.tokenDetails.vin,
      "paCode": this.tokenDetails.dealerCode,
      "country": this.tokenDetails.countryThree,
      "language": this.tokenDetails.language
    }

    this.service.getVindetails(vin).subscribe(
      (data) => {
        this.vinDetail = data
        console.log(this.vinDetail, "vinDetails")
        this.year = this.vinDetail.modelYear
        this.model = this.vinDetail.vehicleLineDescription
      }, (error) => {
        this.year = this.tokenDetails.year
        this.model = this.tokenDetails.model
      })
    this.service.getRAP(this.userId).subscribe((data) => {
      this.RAPDataAvailable = true;
      console.log(data, "data")
      this.rap1 = data;
      if (this.rap1 == null || this.rap1 == undefined || this.rap1 == "") {
        this.getRAPData = true;
        this.paraDisplay = true;
        this.editUsInfo = true
      }
      else {
        this.paraDisplay = false;
        this.getRAPData = false;
        this.editUsInfo = false
        this.firstName = this.rap1.firstName;
        this.lastName = this.rap1.lastName;
        this.phoneNumber = this.rap1.phone;
        this.email = this.rap1.email;
        this.description = this.rap1.description
      }
    }, (error: any) => {
      this.RAPDataAvailable = true;
      this.getRAPData = true;
      this.paraDisplay = true;
      this.editUsInfo = true
      this.modalService.open(this.GETUSERINFOERRORPOPUP)
    })

    this.gnumberSubscription = this.service.sendGnumberToRAP.subscribe((data) => {
      this.Gnumber = data;
    })

  }

  handleFileInput(event: Event,) {
    console.log((event.target as HTMLInputElement).files, "files")
    console.log("event", event)
    this.fileToUpload = (event.target as HTMLInputElement).files?.item(0);
    console.log(this.fileToUpload, "file to upload")
    this.fileType = this.fileToUpload.type;
    console.log(this.fileType, "fileType")

    this.filename = this.fileToUpload.name
    console.log(this.filename, "filename")
    if (this.fileToUpload.size > 8e+7) {
      this.filesizeError = true;
    }
    else {
      this.filesizeError = false;
    }
  }

  reportSubmit() {
    this.firstNameError = false
    this.lastNameError = false
    this.emailError = false
    this.phoneNumberError = false
    this.detailsError = false
    this.emailValidError = false
    this.service.RAPSubmitBtnStatus.next(false);
    if (this.firstName == null || this.firstName == undefined || this.firstName.length == 0) {
      this.submitError = true
      this.firstNameError = true
    }
    else if (this.lastName == null || this.lastName == undefined || this.lastName.length == 0) {
      this.submitError = true
      this.lastNameError = true
    }
    else if (this.phoneNumber == null || this.phoneNumber == undefined || this.phoneNumber.length == 0) {
      this.submitError = true
      this.phoneNumberError = true
    }
    else if (this.email == null || this.email == undefined || this.email.length == 0) {
      this.submitError = true
      this.emailError = true
    }
    else if (/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(this.email) == false) {
      this.submitError = true
      this.emailValidError = true
    }

    else if (this.description == null || this.description == undefined || this.description.length == 0) {
      this.submitError = true
      this.detailsError = true
    }
    else if (this.filesizeError == true) {
      this.submitError = true
    }
    else {
      this.showloader = true;
      this.submitError = false;
      this.req = {
        "requestToAddOrUpdateUserInfo": true,
        "userId": this.userId,
        "userType": this.tokenDetails.userType,
        "paCode": this.tokenDetails.dealerCode.slice(3,),
        "firstName": this.firstName,
        "lastName": this.lastName,
        "email": this.email,
        "phone": this.phoneNumber,
        "language": this.tokenDetails.language,
        "country": this.tokenDetails.countryThree,
        "market": this.tokenDetails.country,
        "supplierName": "",
        "userActivity": null,
        "vin": this.vin,
        "year": this.year,
        "model": this.model,
        "procSgmlId": this.Gnumber,
        "concernTitle": "",
        "concernDescription": this.description,
        "attachedFileName": this.filename,
        "attachedFile": this.fileAttached
      }
      this.service.RAPSubmitBtnStatus.next(true);
      this.service.UploadRAP(this.req).subscribe((data) => {
        this.showloader = false;
        this.service.sendGnumberToRAP.next('');
        this.value = data
        this.value = this.value.substring(15);
        this.editUsInfo = false
        console.log(this.value, "RAP Response")
        this.modalService.open(this.RAPSubmitSuccessPopup);
      },(error: any)=> {
        this.submitError = true;
        this.showloader = false;
        this.modalService.open(this.RAPSubmissionErrorPopup);
      })
      this.showPopup = false
    }
  }
  closeRAPPopupWindow() {
    this.modalService.dismissAll();
  }
  editUserInfo() {
    this.getRAPData = true;
    this.editUsInfo = true;
    this.paraDisplay = false;
  }
  fileAttached: any
  upload(e: any) {
    const file = e.target.files[0];
    const reader: FileReader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e) => {
      this.req = {
        "requestToAddOrUpdateUserInfo": true,
        "userId": this.userId,
        "userType": this.tokenDetails.userType,
        "paCode": this.tokenDetails.dealerCode.slice(3,),
        "firstName": this.firstName,
        "lastName": this.lastName,
        "email": this.email,
        "phone": this.phoneNumber,
        "language": this.tokenDetails.language,
        "country": this.tokenDetails.countryThree,
        "market": this.tokenDetails.country,
        "supplierName": "",
        "userActivity": null,
        "vin": this.vin,
        "year": this.year,
        "model": this.model,
        "procSgmlId": this.Gnumber,
        "concernTitle": "",
        "concernDescription": this.description,
        "attachedFileName": this.filename,
        "attachedFile": reader?.result?.toString().split(',')[1]
      }
      this.fileAttached = reader?.result?.toString().split(',')[1]
      console.log(this.req);

    }
  }

  ngOnDestroy() {
    this.gnumberSubscription.unsubscribe();
  }

}
